"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlattenedFlagsFromChangeset = exports.ldIdentify = exports.ldSubscribe = exports.ldSetup = exports.ldInit = void 0;
var tslib_1 = require("tslib");
var launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");
var ldInit = function (_a) {
    var clientSideID = _a.clientSideID, options = _a.options, context = _a.context, loadMethod = _a.loadMethod, setLdClient = _a.setLdClient, setFlags = _a.setFlags, setIsInitial = _a.setIsInitial, setIsLoading = _a.setIsLoading;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var afterInit, _b, flags, ldClient;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    afterInit = function (_a) {
                        var flags = _a.flags, ldClient = _a.ldClient;
                        setLdClient(ldClient);
                        setFlags(flags);
                        setIsInitial(false);
                        (0, exports.ldSubscribe)({ flags: flags, setFlags: setFlags, ldClient: ldClient, setIsLoading: setIsLoading });
                        setIsLoading(false);
                    };
                    if (!(loadMethod === 'sync')) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, exports.ldSetup)({
                            clientSideID: clientSideID,
                            options: options,
                        })];
                case 1:
                    _b = _c.sent(), flags = _b.flags, ldClient = _b.ldClient;
                    return [2 /*return*/, afterInit({ flags: flags, ldClient: ldClient })];
                case 2: return [2 /*return*/, (0, exports.ldSetup)({
                        clientSideID: clientSideID,
                        options: options,
                        context: context,
                    }).then(function (_a) {
                        var flags = _a.flags, ldClient = _a.ldClient;
                        return afterInit({ flags: flags, ldClient: ldClient });
                    })];
            }
        });
    });
};
exports.ldInit = ldInit;
var ldSetup = function (_a) {
    var clientSideID = _a.clientSideID, options = _a.options, _b = _a.context, context = _b === void 0 ? { anonymous: true } : _b;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var allOptions, ldClient;
        return tslib_1.__generator(this, function (_c) {
            allOptions = tslib_1.__assign({ wrapperName: '@hopin-team/provider-feature-flag', wrapperVersion: '1.0.0' }, options);
            ldClient = (0, launchdarkly_js_client_sdk_1.initialize)(clientSideID, context, allOptions);
            return [2 /*return*/, new Promise(function (resolve) {
                    ldClient.on('ready', function () {
                        resolve({ flags: ldClient.allFlags(), ldClient: ldClient });
                    });
                })];
        });
    });
};
exports.ldSetup = ldSetup;
var ldSubscribe = function (_a) {
    var ldClient = _a.ldClient, setFlags = _a.setFlags, flags = _a.flags, setIsLoading = _a.setIsLoading;
    ldClient.on('change', function (changes) {
        setIsLoading(true);
        var flattened = (0, exports.getFlattenedFlagsFromChangeset)({
            changes: changes,
            flags: flags,
        });
        if (Object.keys(flattened).length) {
            setFlags(function (previousFlags) { return (tslib_1.__assign(tslib_1.__assign({}, previousFlags), flattened)); });
        }
        setIsLoading(false);
    });
};
exports.ldSubscribe = ldSubscribe;
var ldIdentify = function (_a) {
    var ldClient = _a.ldClient, key = _a.key, custom = _a.custom;
    return ldClient.identify({ key: key, custom: custom });
};
exports.ldIdentify = ldIdentify;
var getFlattenedFlagsFromChangeset = function (_a) {
    var changes = _a.changes, flags = _a.flags;
    var flattened = {};
    for (var key in changes) {
        if (!flags || flags[key] !== undefined) {
            flattened[key] = changes[key].current;
        }
    }
    return flattened;
};
exports.getFlattenedFlagsFromChangeset = getFlattenedFlagsFromChangeset;
//# sourceMappingURL=launchDarkly.js.map